import GoodbyeGroup from './GoodbyeGroup.presenter';

export default GoodbyeGroup;